import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { CompareDetail } from '@src/pages/Compare';

export const Route = createLazyFileRoute('/compare/servicenow')({
  component: ServiceNowComparePage,
});

function ServiceNowComparePage() {
  return (
    <DefaultLayout>
      <CompareDetail competitorId="servicenow" />
    </DefaultLayout>
  );
}
